export const URL_REGEX = /(https?:\/\/[^\s]+)/g
